import React, { useState, useEffect } from 'react';

const FormularioRetiro = () => {
  const [formData, setFormData] = useState({
    nome: '',
    telefone: '',
    email: '',
    idade: '',
    tipo: 'membro',
    participantes: [],
    tipoPacote: 'INTEGRAL',
    tipoPagamento: 'AVISTA',
    numeroParcelas: 1,
    valorDoacao: 0,
    naoTemComoPagar: false,
    diasVisitante: {
      quinta: false,
      sexta: false,
      sabado: false
    }
  });

  const [inscricaoEnviada, setInscricaoEnviada] = useState(false);
  const [valorTotal, setValorTotal] = useState(0);
  const [resumoParticipantes, setResumoParticipantes] = useState({
    adultos: 0,
    criancas6a10: 0,
    criancasMenor6: 0
  });
  const [idInscricao, setIdInscricao] = useState('');
  const [erroIdade, setErroIdade] = useState('');

  const precos = {
    INTEGRAL: {
      adulto: 400,
      crianca6a10: 200,
      criancaMenor6: 0
    },
    PARCIAL: {
      adulto: 220,
      crianca6a10: 110,
      criancaMenor6: 0
    },
    VISITANTE_DIARIA: {
      adulto: 100, // diária de alimentação (almoço/jantar) para adultos
      crianca6a10: 50, // diária de alimentação (almoço/jantar) para crianças 6-10 anos
      criancaMenor6: 0 // crianças de 0-5 anos não pagam
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      if (name === 'diasVisitante.quinta' || name === 'diasVisitante.sexta' || name === 'diasVisitante.sabado') {
        // Tratamento especial para os checkboxes de dias do visitante
        const [parent, key] = name.split('.');
        setFormData({
          ...formData,
          diasVisitante: {
            ...formData.diasVisitante,
            [key]: checked
          }
        });
      } else {
        setFormData({ ...formData, [name]: checked });
      }
    } else {
      // Se o tipo de participante for "visitante" ou "catecumenos", restringir opções
      if (name === 'tipo') {
        const novoTipo = value;
        let novoTipoPacote = formData.tipoPacote;
        let novoTipoPagamento = formData.tipoPagamento;
        let novoNumeroParcelas = formData.numeroParcelas;

        // Restringir pacote parcial para "visitante" e "catecumenos"
        if (novoTipo === 'visitante' || novoTipo === 'catecumenos') {
          novoTipoPacote = 'INTEGRAL'; // Forçar pacote Integral
          novoTipoPagamento = 'AVISTA'; // Forçar pagamento à vista
          novoNumeroParcelas = 1; // Resetar número de parcelas
        }

        setFormData({
          ...formData,
          tipo: novoTipo,
          tipoPacote: novoTipoPacote,
          tipoPagamento: novoTipoPagamento,
          numeroParcelas: novoNumeroParcelas
        });
      } else if (name === 'tipoPacote') {
        // Impedir seleção de "Parcial" para "visitante" e "catecumenos"
        if ((formData.tipo === 'visitante' || formData.tipo === 'catecumenos') && value === 'PARCIAL') {
          return; // Não permite mudar para "Parcial"
        }
        setFormData({ ...formData, [name]: value });
      } else if (name === 'tipoPagamento') {
        // Impedir seleção de "Parcelado" para "visitante" e "catecumenos"
        if ((formData.tipo === 'visitante' || formData.tipo === 'catecumenos') && value === 'PARCELADO') {
          return; // Não permite mudar para "Parcelado"
        }
        setFormData({
          ...formData,
          tipoPagamento: value,
          numeroParcelas: value === 'AVISTA' ? 1 : 2
        });
      } else if (name === 'idade') {
        const idade = parseInt(value) || 0;
        if (idade < 18 && value !== '') {
          setErroIdade('O responsável deve ter 18 anos ou mais.');
        } else {
          setErroIdade('');
        }
        setFormData({ ...formData, [name]: value });
      } else {
        setFormData({ ...formData, [name]: value });
      }
    }
  };

  const formatarTelefone = (e) => {
    let value = e.target.value.replace(/\D/g, '');
    if (value.length > 11) value = value.slice(0, 11);
    if (value.length > 7) {
      value = `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7)}`;
    } else if (value.length > 2) {
      value = `(${value.slice(0, 2)}) ${value.slice(2)}`;
    }
    setFormData({ ...formData, telefone: value });
  };

  const adicionarParticipante = () => {
    setFormData({
      ...formData,
      participantes: [...formData.participantes, { nome: '', idade: '' }]
    });
  };

  const removerParticipante = (index) => {
    const novosParticipantes = [...formData.participantes];
    novosParticipantes.splice(index, 1);
    setFormData({ ...formData, participantes: novosParticipantes });
  };

  const handleParticipanteChange = (index, campo, valor) => {
    const novosParticipantes = [...formData.participantes];
    novosParticipantes[index] = { ...novosParticipantes[index], [campo]: valor };
    setFormData({ ...formData, participantes: novosParticipantes });
  };

  useEffect(() => {
    let numeroAdultos = 0;
    let numeroCriancas6a10 = 0;
    let numeroCriancasMenor6 = 0;

    const idadeResponsavel = parseInt(formData.idade) || 0;
    if (idadeResponsavel >= 10) numeroAdultos += 1;
    else if (idadeResponsavel >= 6) numeroCriancas6a10 += 1;
    else if (idadeResponsavel > 0) numeroCriancasMenor6 += 1;

    formData.participantes.forEach(participante => {
      const idade = parseInt(participante.idade) || 0;
      if (idade >= 10) numeroAdultos += 1;
      else if (idade >= 6) numeroCriancas6a10 += 1;
      else if (idade > 0) numeroCriancasMenor6 += 1;
    });

    setResumoParticipantes({
      adultos: numeroAdultos,
      criancas6a10: numeroCriancas6a10,
      criancasMenor6: numeroCriancasMenor6
    });

    if (formData.naoTemComoPagar) {
      setValorTotal(parseInt(formData.valorDoacao) || 0);
    } else if (formData.tipo === 'visitante') {
      // Cálculo especial para visitantes baseado nos dias selecionados
      const diasSelecionados = Object.values(formData.diasVisitante).filter(Boolean).length;
      
      if (diasSelecionados === 0) {
        setValorTotal(parseInt(formData.valorDoacao) || 0);
        return;
      }
      
      const precosDiaria = precos.VISITANTE_DIARIA;
      const valorAdultos = numeroAdultos * precosDiaria.adulto * diasSelecionados;
      const valorCriancas = numeroCriancas6a10 * precosDiaria.crianca6a10 * diasSelecionados;
      const valorDoacao = parseInt(formData.valorDoacao) || 0;
      const valorTotal = valorAdultos + valorCriancas + valorDoacao;
      setValorTotal(valorTotal);
    } else {
      const precosPlano = precos[formData.tipoPacote];
      const valorAdultos = numeroAdultos * precosPlano.adulto;
      const valorCriancas = numeroCriancas6a10 * precosPlano.crianca6a10;
      const valorDoacao = parseInt(formData.valorDoacao) || 0;
      const valorTotal = valorAdultos + valorCriancas + valorDoacao;
      setValorTotal(valorTotal);
    }
  }, [formData]);

  const gerarIdInscricao = () => {
    return 'INSC-' + Math.random().toString(36).substr(2, 9).toUpperCase();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const idadeResponsavel = parseInt(formData.idade) || 0;
    if (idadeResponsavel < 18) {
      setErroIdade('O responsável deve ter 18 anos ou mais.');
      alert('O responsável deve ter 18 anos ou mais para realizar a inscrição.');
      return;
    }

    try {
      const novoId = gerarIdInscricao();
      setIdInscricao(novoId);
      const dadosParaEnviar = { ...formData, valorTotal, resumoParticipantes, idInscricao: novoId };
      const apiUrl = 'https://script.google.com/macros/s/AKfycbxBRy5hNZuXlCMD2397O7hTpF3V5ZGZkMnhrM5h9Je0k0fa6P29Q4JqVaJrX_ToMTFEnw/exec';
      await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dadosParaEnviar),
        mode: 'no-cors'
      });
      setInscricaoEnviada(true);
    } catch (error) {
      console.error('Erro ao enviar inscrição:', error);
      alert('Ocorreu um erro ao enviar sua inscrição. Por favor, tente novamente.');
    }
  };

  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
  };

  const isVisitanteOuCatecumeno = formData.tipo === 'visitante' || formData.tipo === 'catecumenos';

  if (inscricaoEnviada) {
    return (
      <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-md">
        <h1 className="text-2xl font-bold text-center text-green-700 mb-6">
          Inscrição Realizada com Sucesso!
        </h1>
        <div className="mb-6 text-center">
          <p className="mb-2">Um email de confirmação foi enviado para: <strong>{formData.email}</strong></p>
          <p>Código da inscrição: <strong>{idInscricao}</strong></p>
          <p>Data da inscrição: <strong>{new Date().toLocaleDateString('pt-BR')}</strong></p>
        </div>
        <div className="mb-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
          <h2 className="text-xl font-semibold mb-4">Resumo da Inscrição</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <h3 className="font-medium">Responsável:</h3>
              <p>{formData.nome}</p>
            </div>
            <div>
              <h3 className="font-medium">Contato:</h3>
              <p>{formData.telefone} | {formData.email}</p>
            </div>
          </div>
          <div className="mb-4">
            <h3 className="font-medium">Tipo de Pacote:</h3>
            <p>
              {formData.naoTemComoPagar ? 'Não tenho como pagar' :
                formData.tipo === 'visitante' ? (
                  <>
                    Visitante - Dias selecionados:&nbsp;
                    {formData.diasVisitante.quinta && 'Quinta-feira (17/04), '}
                    {formData.diasVisitante.sexta && 'Sexta-feira (18/04), '}
                    {formData.diasVisitante.sabado && 'Sábado (19/04)'}
                    {!formData.diasVisitante.quinta && !formData.diasVisitante.sexta && !formData.diasVisitante.sabado && 'Nenhum dia selecionado'}
                  </>
                ) :
                `${formData.tipoPacote === 'INTEGRAL' ? 'Integral' : 'Parcial'} 
                 ${formData.tipoPagamento === 'AVISTA' ? 'à Vista' : `Parcelado (${formData.numeroParcelas}x)`}`}
            </p>
          </div>
          <div className="mb-4">
            <h3 className="font-medium mb-2">Participantes:</h3>
            <ul className="list-disc list-inside">
              <li>{formData.nome} ({formData.idade} anos)</li>
              {formData.participantes.map((p, idx) => (
                <li key={idx}>{p.nome} ({p.idade} anos)</li>
              ))}
            </ul>
          </div>
          <div className="mb-4 pt-4 border-t border-gray-200">
            <div className="grid grid-cols-2 gap-2">
              {formData.tipo === 'visitante' ? (
                <>
                  {/* Resumo para visitantes na tela de confirmação */}
                  {Object.entries(formData.diasVisitante).map(([dia, selecionado]) => {
                    if (!selecionado) return null;
                    const diaNome = dia === 'quinta' ? 'Quinta-feira (17/04)' : dia === 'sexta' ? 'Sexta-feira (18/04)' : 'Sábado (19/04)';
                    return (
                      <React.Fragment key={dia}>
                        <span className="col-span-2 font-medium pt-2">{diaNome}:</span>
                        <span>Adultos (10+ anos):</span>
                        <span className="text-right">{resumoParticipantes.adultos} x {formatarMoeda(precos.VISITANTE_DIARIA.adulto)}</span>
                        <span>Crianças (6-10 anos):</span>
                        <span className="text-right">{resumoParticipantes.criancas6a10} x {formatarMoeda(precos.VISITANTE_DIARIA.crianca6a10)}</span>
                        <span>Crianças (menores de 6):</span>
                        <span className="text-right">{resumoParticipantes.criancasMenor6} x R$ 0,00</span>
                      </React.Fragment>
                    );
                  })}
                </>
              ) : (
                <>
                  <span>Adultos (10+ anos):</span>
                  <span className="text-right">{resumoParticipantes.adultos} x {formatarMoeda(precos[formData.tipoPacote].adulto)}</span>
                  <span>Crianças (6-10 anos):</span>
                  <span className="text-right">{resumoParticipantes.criancas6a10} x {formatarMoeda(precos[formData.tipoPacote].crianca6a10)}</span>
                  <span>Crianças (menores de 6):</span>
                  <span className="text-right">{resumoParticipantes.criancasMenor6} x R$ 0,00</span>
                </>
              )}
              {parseInt(formData.valorDoacao) > 0 && (
                <>
                  <span>Doação:</span>
                  <span className="text-right">{formatarMoeda(parseInt(formData.valorDoacao))}</span>
                </>
              )}
              <span className="font-semibold pt-2 border-t border-gray-200">Total:</span>
              <span className="text-right font-semibold pt-2 border-t border-gray-200">{formatarMoeda(valorTotal)}</span>
              {formData.tipoPagamento === 'PARCELADO' && !formData.naoTemComoPagar && valorTotal > 0 && (
                <>
                  <span className="text-sm text-gray-600">Parcelamento:</span>
                  <span className="text-right text-sm text-gray-600">{formData.numeroParcelas}x de {formatarMoeda(valorTotal / formData.numeroParcelas)}</span>
                </>
              )}
            </div>
          </div>
        </div>
        {!formData.naoTemComoPagar || parseInt(formData.valorDoacao) > 0 ? (
          <div className="mb-6">
            <h2 className="text-xl font-semibold mb-4 text-center">Pagamento</h2>
            <div className="flex flex-col items-center mb-6">
              <div className="p-4 bg-white border-2 border-gray-300 rounded-lg shadow-sm mb-3">
                <img src="/qrcode-ipcohama.jpg" alt="QR Code para pagamento" className="mx-auto w-48 h-48" />
              </div>
              <p className="text-center">Escaneie o QR Code acima para fazer o pagamento via PIX</p>
              <p className="text-center mt-2">Ou use o número do PIX: <strong>98981101113</strong></p>
              <p className="text-center">Titular: <strong>Francisco Cauê de Oliveira Paula (Tesoureiro IPCohama)</strong></p>
              <p className="text-sm text-gray-600 mt-2">
                Após o pagamento, envie o comprovante para o WhatsApp: 
                <a href="https://wa.me/5598987572060" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
                  (98) 98757-2060
                </a>
              </p>
            </div>
          </div>
        ) : (
          <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg text-center">
            <p className="text-green-700">Sua inscrição foi registrada sem cobrança. Não é necessário realizar pagamento.</p>
          </div>
        )}
        {/* Nova Seção: Endereço e Mapa */}
        <div className="mb-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
          <h2 className="text-xl font-semibold mb-4">Local do Retiro</h2>
          <p><strong>Endereço:</strong> R. da Prata, 100 - Inhaúma, Raposa - MA, 65138-000</p>
          <p className="mt-2">
            <a href="https://maps.app.goo.gl/5FUdKc9GRpRbmUG76" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
              Ver no Google Maps
            </a>
          </p>
          <div className="mt-4">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4193.83305071354!2d-44.10091508924764!3d-2.4343565975343884!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7f6ea82d5ed9b41%3A0x5653e6e0ef528a1a!2sFazendinha%20Parque%20Raposa!5e1!3m2!1spt-BR!2sbr!4v1743560556149!5m2!1spt-BR!2sbr"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="rounded-lg"
            ></iframe>
          </div>
        </div>
        {/* Nova Seção: Programação */}
        <div className="mb-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
          <h2 className="text-xl font-semibold mb-4">Programação do Retiro</h2>
          <p><strong>RETIRO IPCOHAMA 2025</strong></p>
          <p><strong>TEMA:</strong> "Nada SE ACRESCENTARÁ"</p>
          <p><strong>DATAS E LOCAIS:</strong></p>
          <ul className="list-disc list-inside">
            <li>17 a 19/04/2025: Fazendinha</li>
            <li>20/04/2025 (domingo): Igreja Presbiteriana da Cohama</li>
          </ul>
          <p className="mt-2"><strong>PROGRAMAÇÃO:</strong></p>
          <p><strong>QUINTA-FEIRA (Fazendinha)</strong></p>
          <ul className="list-disc list-inside">
            <li>20:00 - A suficiência das Escrituras para a piedade</li>
          </ul>
          <p><strong>SEXTA-FEIRA (Fazendinha)</strong></p>
          <ul className="list-disc list-inside">
            <li>09:00 - Sola Scriptura</li>
            <li>19:00 - Cessação do dom de Línguas</li>
          </ul>
          <p><strong>SÁBADO (Fazendinha)</strong></p>
          <ul className="list-disc list-inside">
            <li>09:00 - Cessação do dom de Profecias</li>
          </ul>
          <p><strong>DOMINGO (Na IPCohama)</strong></p>
          <ul className="list-disc list-inside">
            <li>09:00 - Devocional</li>
            <li>09:45 - Fechamento do Cânon</li>
            <li>15:30 - Sermão: A Palavra Final (Hebreus 1.1-2)</li>
          </ul>
        </div>
        <div className="flex justify-center space-x-4">
          <button onClick={() => window.print()} className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded">Imprimir Comprovante</button>
          <button onClick={() => window.location.reload()} className="bg-gray-500 hover:bg-gray-600 text-white py-2 px-4 rounded">Nova Inscrição</button>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-md">
      <img src="/Retiro-202501.png" alt="Arte do Retiro IPCohama 2025" className="mx-auto mb-6 w-full max-w-md" />
      <h1 className="text-2xl font-bold text-center mb-6">Retiro IPCohama 2025</h1>
      <form onSubmit={handleSubmit}>
        {/* Dados Pessoais */}
        <div className="mb-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
          <h2 className="text-xl font-semibold mb-4">Dados Pessoais</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <label className="block text-gray-700 mb-2" htmlFor="nome">Nome Completo *</label>
              <input type="text" id="nome" name="nome" required className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500" value={formData.nome} onChange={handleChange} />
            </div>
            <div>
              <label className="block text-gray-700 mb-2" htmlFor="idade">Idade *</label>
              <input
                type="number"
                id="idade"
                name="idade"
                min="18"
                max="120"
                required
                className={`w-full px-3 py-2 border ${erroIdade ? 'border-red-500' : 'border-gray-300'} rounded focus:ring-2 focus:ring-blue-500`}
                value={formData.idade}
                onChange={handleChange}
              />
              {erroIdade && <p className="text-red-500 text-sm mt-1">{erroIdade}</p>}
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <label className="block text-gray-700 mb-2" htmlFor="telefone">Telefone *</label>
              <input type="tel" id="telefone" name="telefone" required className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500" value={formData.telefone} onChange={formatarTelefone} placeholder="(00) 00000-0000" />
            </div>
            <div>
              <label className="block text-gray-700 mb-2" htmlFor="email">Email *</label>
              <input type="email" id="email" name="email" required className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500" value={formData.email} onChange={handleChange} />
            </div>
          </div>
          <div>
            <label className="block text-gray-700 mb-2">Tipo de Participante *</label>
            <div className="flex space-x-4">
              <label className="inline-flex items-center">
                <input type="radio" name="tipo" value="membro" checked={formData.tipo === 'membro'} onChange={handleChange} className="mr-2" />
                Membro
              </label>
              <label className="inline-flex items-center">
                <input type="radio" name="tipo" value="catecumenos" checked={formData.tipo === 'catecumenos'} onChange={handleChange} className="mr-2" />
                Catecúmenos
              </label>
              <label className="inline-flex items-center">
                <input type="radio" name="tipo" value="visitante" checked={formData.tipo === 'visitante'} onChange={handleChange} className="mr-2" />
                Visitante
              </label>
            </div>
          </div>
        </div>

        {/* Participantes Adicionais */}
        <div className="mb-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
          <h2 className="text-xl font-semibold mb-4">Participantes Adicionais</h2>
          {formData.participantes.map((participante, index) => (
            <div key={index} className="mb-4 pb-4 border-b border-gray-200">
              <div className="flex justify-between items-center mb-2">
                <h3 className="font-medium">Participante {index + 1}</h3>
                <button type="button" onClick={() => removerParticipante(index)} className="text-red-500 hover:text-red-700">Remover</button>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-gray-700 mb-2">Nome Completo *</label>
                  <input type="text" required className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500" value={participante.nome} onChange={(e) => handleParticipanteChange(index, 'nome', e.target.value)} />
                </div>
                <div>
                  <label className="block text-gray-700 mb-2">Idade *</label>
                  <input type="number" min="0" max="120" required className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500" value={participante.idade} onChange={(e) => handleParticipanteChange(index, 'idade', e.target.value)} />
                </div>
              </div>
            </div>
          ))}
          <button type="button" onClick={adicionarParticipante} className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded">+ Adicionar Participante</button>
        </div>

        {/* Plano de Pagamento */}
        <div className="mb-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
          <h2 className="text-xl font-semibold mb-4">Plano de Pagamento</h2>
          
          {/* Seção de dias para visitantes */}
          {formData.tipo === 'visitante' && !formData.naoTemComoPagar && (
            <div className="mb-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
              <h3 className="font-semibold text-lg mb-3">Dias de Participação</h3>
              <p className="mb-3 text-sm">Por favor selecione os dias em que deseja participar:</p>
              <div className="space-y-2">
                <label className="flex items-center">
                  <input 
                    type="checkbox"
                    name="diasVisitante.quinta"
                    checked={formData.diasVisitante.quinta}
                    onChange={handleChange}
                    className="mr-2"
                  />
                  <span>Quinta-feira (17/04)</span>
                </label>
                <label className="flex items-center">
                  <input 
                    type="checkbox"
                    name="diasVisitante.sexta"
                    checked={formData.diasVisitante.sexta}
                    onChange={handleChange}
                    className="mr-2"
                  />
                  <span>Sexta-feira (18/04)</span>
                </label>
                <label className="flex items-center">
                  <input 
                    type="checkbox"
                    name="diasVisitante.sabado"
                    checked={formData.diasVisitante.sabado}
                    onChange={handleChange}
                    className="mr-2"
                  />
                  <span>Sábado (19/04)</span>
                </label>
              </div>
              
              {Object.values(formData.diasVisitante).filter(Boolean).length === 0 && (
                <p className="text-red-500 text-sm mt-2">
                  Por favor, selecione pelo menos um dia para participar.
                </p>
              )}
              
              <div className="mt-4 p-2 bg-yellow-50 border border-yellow-200 rounded-lg">
                <h4 className="font-medium mb-2">Valores por dia:</h4>
                <ul className="list-disc list-inside text-sm">
                  <li>Adultos (10+ anos): {formatarMoeda(precos.VISITANTE_DIARIA.adulto)} por dia</li>
                  <li>Crianças (6-10 anos): {formatarMoeda(precos.VISITANTE_DIARIA.crianca6a10)} por dia</li>
                  <li>Crianças (0-5 anos): Não pagam</li>
                </ul>
              </div>
            </div>
          )}
          
          <div className="mb-4 text-left">
            <label className="inline-flex items-center mb-4">
              <input type="checkbox" name="naoTemComoPagar" checked={formData.naoTemComoPagar} onChange={handleChange} className="mr-2" />
              <span className="font-medium">Infelizmente não tenho como pagar.</span>
            </label>
            {!formData.naoTemComoPagar && (
              <div className="space-y-4">
                <div className="text-left">
                  <label className="block text-gray-700 mb-2 text-left">Tipo de Pacote *</label>
                  <div className="flex space-x-4 justify-start">
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="tipoPacote"
                        value="INTEGRAL"
                        checked={formData.tipoPacote === 'INTEGRAL'}
                        onChange={handleChange}
                        className="mr-2"
                      />
                      Integral
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="tipoPacote"
                        value="PARCIAL"
                        checked={formData.tipoPacote === 'PARCIAL'}
                        onChange={handleChange}
                        className="mr-2"
                        disabled={isVisitanteOuCatecumeno}
                      />
                      Parcial
                    </label>
                  </div>
                  {isVisitanteOuCatecumeno && formData.tipoPacote === 'PARCIAL' && (
                    <p className="text-red-500 text-sm mt-1">Visitantes e Catecúmenos só podem escolher o pacote Integral.</p>
                  )}
                </div>
                <div className="text-left">
                  <label className="block text-gray-700 mb-2 text-left">Forma de Pagamento *</label>
                  <div className="flex space-x-4 justify-start">
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="tipoPagamento"
                        value="AVISTA"
                        checked={formData.tipoPagamento === 'AVISTA'}
                        onChange={handleChange}
                        className="mr-2"
                      />
                      À Vista
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="tipoPagamento"
                        value="PARCELADO"
                        checked={formData.tipoPagamento === 'PARCELADO'}
                        onChange={handleChange}
                        className="mr-2"
                        disabled={isVisitanteOuCatecumeno}
                      />
                      Parcelado
                    </label>
                  </div>
                  {isVisitanteOuCatecumeno && formData.tipoPagamento === 'PARCELADO' && (
                    <p className="text-red-500 text-sm mt-1">Visitantes e Catecúmenos só podem pagar à vista.</p>
                  )}
                  {formData.tipoPagamento === 'PARCELADO' && !isVisitanteOuCatecumeno && (
                    <div className="mt-2">
                      <label className="block text-gray-700 mb-2 text-left">Número de Parcelas *</label>
                      <select name="numeroParcelas" value={formData.numeroParcelas} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500">
                        {[2, 3, 4, 5].map(num => (
                          <option key={num} value={num}>
                            {num}x de {formatarMoeda(valorTotal / num)}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Doação */}
        <div className="mb-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
          <h2 className="text-xl font-semibold mb-4">Doação (Opcional)</h2>
          <div>
            <label className="block text-gray-700 mb-2">
              Valor da Doação: {formatarMoeda(parseInt(formData.valorDoacao) || 0)}
            </label>
            <input
              type="range"
              min="0"
              max="5000"
              step="10"
              className="w-full h-3 bg-gray-200 rounded-lg appearance-none cursor-pointer"
              value={formData.valorDoacao}
              onChange={(e) => setFormData({ ...formData, valorDoacao: e.target.value })}
            />
            <div className="flex justify-between text-sm text-gray-500 mt-1">
              <span>R$ 0</span>
              <span>R$ 5000</span>
            </div>
            <div className="flex flex-wrap gap-2 mt-4">
              {[0, 10, 100, 500, 1000, 5000].map(valor => (
                <button key={valor} type="button" className="bg-blue-100 hover:bg-blue-200 text-blue-800 px-3 py-1 rounded" onClick={() => setFormData({ ...formData, valorDoacao: valor })}>
                  {formatarMoeda(valor)}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Resumo */}
        <div className="mb-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
          <h2 className="text-xl font-semibold mb-4 text-blue-800">Resumo</h2>
          <div className="grid grid-cols-2 gap-2">
            {formData.tipo === 'visitante' ? (
              <>
                {/* Resumo para visitantes */}
                {Object.entries(formData.diasVisitante).map(([dia, selecionado]) => {
                  if (!selecionado) return null;
                  const diaNome = dia === 'quinta' ? 'Quinta-feira (17/04)' : dia === 'sexta' ? 'Sexta-feira (18/04)' : 'Sábado (19/04)';
                  return (
                    <React.Fragment key={dia}>
                      <span className="col-span-2 font-medium pt-2">{diaNome}:</span>
                      <span>Adultos (10+ anos):</span>
                      <span className="text-right">{resumoParticipantes.adultos} x {formatarMoeda(precos.VISITANTE_DIARIA.adulto)}</span>
                      <span>Crianças (6-10 anos):</span>
                      <span className="text-right">{resumoParticipantes.criancas6a10} x {formatarMoeda(precos.VISITANTE_DIARIA.crianca6a10)}</span>
                      <span>Crianças (menores de 6):</span>
                      <span className="text-right">{resumoParticipantes.criancasMenor6} x R$ 0,00</span>
                    </React.Fragment>
                  );
                })}
              </>
            ) : (
              <>
                <span>Adultos (10+ anos):</span>
                <span className="text-right">{resumoParticipantes.adultos} x {formatarMoeda(precos[formData.tipoPacote].adulto)}</span>
                <span>Crianças (6-10 anos):</span>
                <span className="text-right">{resumoParticipantes.criancas6a10} x {formatarMoeda(precos[formData.tipoPacote].crianca6a10)}</span>
                <span>Crianças (menores de 6):</span>
                <span className="text-right">{resumoParticipantes.criancasMenor6} x R$ 0,00</span>
              </>
            )}
            
            {parseInt(formData.valorDoacao) > 0 && (
              <>
                <span>Doação:</span>
                <span className="text-right">{formatarMoeda(parseInt(formData.valorDoacao))}</span>
              </>
            )}
            <span className="font-semibold pt-2 border-t border-gray-200">Total:</span>
            <span className="text-right font-semibold pt-2 border-t border-gray-200">{formatarMoeda(valorTotal)}</span>
            {formData.tipoPagamento === 'PARCELADO' && !formData.naoTemComoPagar && valorTotal > 0 && (
              <>
                <span className="text-sm text-gray-600">Parcelamento:</span>
                <span className="text-right text-sm text-gray-600">{formData.numeroParcelas}x de {formatarMoeda(valorTotal / formData.numeroParcelas)}</span>
              </>
            )}
          </div>
        </div>

        {/* Nova Seção: Endereço e Mapa */}
        <div className="mb-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
          <h2 className="text-xl font-semibold mb-4">Local do Retiro</h2>
          <p><strong>Endereço:</strong> R. da Prata, 100 - Inhaúma, Raposa - MA, 65138-000</p>
          <p className="mt-2">
            <a href="https://maps.app.goo.gl/5FUdKc9GRpRbmUG76" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
              Ver no Google Maps
            </a>
          </p>
          <div className="mt-4">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4193.83305071354!2d-44.10091508924764!3d-2.4343565975343884!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7f6ea82d5ed9b41%3A0x5653e6e0ef528a1a!2sFazendinha%20Parque%20Raposa!5e1!3m2!1spt-BR!2sbr!4v1743560556149!5m2!1spt-BR!2sbr"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="rounded-lg"
            ></iframe>
          </div>
        </div>

        {/* Nova Seção: Programação */}
        <div className="mb-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
          <h2 className="text-xl font-semibold mb-4">Programação do Retiro</h2>
          <p><strong>RETIRO IPCOHAMA 2025</strong></p>
          <p><strong>TEMA:</strong> "Nada SE ACRESCENTARÁ"</p>
          <p><strong>DATAS E LOCAIS:</strong></p>
          <ul className="list-disc list-inside">
            <li>17 a 19/04/2025: Fazendinha</li>
            <li>20/04/2025 (domingo): Igreja Presbiteriana da Cohama</li>
          </ul>
          <p className="mt-2"><strong>PROGRAMAÇÃO:</strong></p>
          <p><strong>QUINTA-FEIRA (Fazendinha)</strong></p>
          <ul className="list-disc list-inside">
            <li>20:00 - A suficiência das Escrituras para a piedade</li>
          </ul>
          <p><strong>SEXTA-FEIRA (Fazendinha)</strong></p>
          <ul className="list-disc list-inside">
            <li>09:00 - Sola Scriptura</li>
            <li>19:00 - Cessação do dom de Línguas</li>
          </ul>
          <p><strong>SÁBADO (Fazendinha)</strong></p>
          <ul className="list-disc list-inside">
            <li>09:00 - Cessação do dom de Profecias</li>
          </ul>
          <p><strong>DOMINGO (Na IPCohama)</strong></p>
          <ul className="list-disc list-inside">
            <li>09:00 - Devocional</li>
            <li>09:45 - Fechamento do Cânon</li>
            <li>15:30 - Sermão: A Palavra Final (Hebreus 1.1-2)</li>
          </ul>
        </div>

        <div className="text-center">
          <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded">Finalizar Inscrição</button>
        </div>
      </form>
    </div>
  );
};

export default FormularioRetiro;